import { resetScrollbar, setFlexDFFDCF1, setTextRightArabic, styled } from "theme";

type Props = {
  isArabic: boolean;
};

export const SGroupTableBody = styled.div<Props>`
  overflow-x: hidden;
  overflow-y: scroll;

  ${setFlexDFFDCF1};
  ${resetScrollbar};
  ${setTextRightArabic()};
`;
